import { TabBase } from '../TabBase/index';
import type { ITabsGroup } from "libs/design-system/src/types/tabs/tabs_group";
import styles from "./tabs-group.module.scss";

export const TabsGroup = ({
  type = 'line',
  orientation,
  tabsProps
}: ITabsGroup) => {
  return (
    <>
      {
        tabsProps &&
        <div
          className={styles["tabs-group"]}
          data-tabs-group-orientation={orientation}
          data-tabs-group-type={type}
        >
          {tabsProps.map((tab, index) => {
            return (
              <TabBase
                type={type}
                {...tab}
                key={`tabs-group-tab-${index}`}
              />
            )
          })}
        </div>
      }
    </>
  )
};